module.exports = {"id":"dp2_6l1q5","text":"Managing Digital Identity","instructions":"Information shared online can remain accessible for long periods.","groupTitle":"Digital Profiler Knowledge Matrix","multiselect":false,"category":"2.6","questionType":"PickOne","random":false,"options":[{"id":"dp2_6l1q5-a1","text":"True","score":1.8},{"id":"dp2_6l1q5-a2","text":"Not sure","score":0},{"id":"dp2_6l1q5-a3","text":"False","score":0}]}


//////////////////
// WEBPACK FOOTER
// ./src/constants/dp/questions/cat2.6/l1q5.json
// module id = 1093
// module chunks = 41